<template>
  <v-card>
    <v-row class="container-row">
      <!-- DETAILS -->
      <v-col>
        <v-toolbar flat color="FFFFFF">
          <v-btn
            icon
            @click="closeDialog()"
            class="close-btn"
            color="#9AABB8"
            height="40"
            width="40"
          >
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <!-- Header (Date and Logos) -->
        <v-row
          v-for="(matchBet, index) in matchDetails.matchMarkets"
          :key="'comment-' + index"
        >
          <v-col cols="12" class="details">
            <!-- BIGODDS MARKETS FOR MULTIPLE PROGNOSTIC -->
            <v-row class="users-row">
              <v-col>&nbsp;</v-col>
              <v-col
                v-if="
                  !isTiroCerteiro() &&
                  matchBet.bigoddsMarkets.length > 0 &&
                  matchDetails.matchMarkets.length > 1 &&
                  index == 0
                "
              >
                <v-btn
                  depressed
                  color="#BEE6CF"
                  @click="showBigoddsPrognostics = true"
                  width="206"
                  height="40"
                  class="bigodds-btn"
                  v-if="matchBet.bigoddsMarkets"
                >
                  <v-icon small left>$icon-prognosis</v-icon>({{
                    matchBet.bigoddsMarkets.length
                  }}) Prognóstico Bigodds
                </v-btn>
              </v-col>
            </v-row>
            <!-- TEAMS -->
            <v-row>
              <!-- Team Logos -->
              <v-col class="team-logos" cols="12">
                <div class="logos-container">
                  <v-list-item-avatar
                    class="team-icon"
                    size="72"
                    style="z-index: 1"
                  >
                    <v-img
                      :src="matchBet.match.homeTeam.image"
                      aspect-ratio="1"
                    ></v-img>
                  </v-list-item-avatar>
                  <v-list-item-avatar class="team-icon" size="72">
                    <v-img
                      :src="matchBet.match.awayTeam.image"
                      aspect-ratio="1"
                    ></v-img>
                  </v-list-item-avatar>
                </div>
              </v-col>
              <!-- Date and Time -->
              <v-col class="match-details" cols="12">
                <v-list-item style="padding: 0">
                  <v-list-item-content style="padding: 0">
                    <v-list-item-subtitle class="green-label">{{
                      matchBet.match.competition.name
                    }}</v-list-item-subtitle>
                    <v-list-item-title class="team-names">{{
                      matchBet.match.homeTeam.name
                    }}</v-list-item-title>
                    <v-list-item-title class="team-names">{{
                      matchBet.match.awayTeam.name
                    }}</v-list-item-title>
                    <v-list-item-subtitle class="match-date"
                      >{{ matchBet.match.hour }} .
                      {{ matchBet.match.date }}</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
            <!-- Labels -->
            <v-row class="chips-row">
              <v-col cols="12" style="padding-top: 4px">
                <v-chip label x-small>{{ matchBet.match.country.name }}</v-chip>
                <v-chip label x-small>{{ matchBet.match.sport.name }}</v-chip>
                <v-chip label x-small>{{
                  matchBet.match.competition.name
                }}</v-chip>
              </v-col>
            </v-row>
            <!-- USERS -->
            <v-row class="users-row">
              <v-col>
                <UserAvatarList
                  :users="users"
                  :avatarSize="40"
                  :avatarOverlay="0.75"
                  :showLabel="false"
                ></UserAvatarList>
              </v-col>
              <v-col
                v-if="
                  !isBigometro() &&
                  matchBet.bigoddsMarkets.length > 0 &&
                  matchDetails.matchMarkets.length == 1
                "
              >
                <v-btn
                  depressed
                  color="#BEE6CF"
                  @click="showBigoddsPrognostics = true"
                  width="206"
                  height="40"
                  class="bigodds-btn"
                  v-if="matchBet.bigoddsMarkets"
                >
                  <v-icon small left>$icon-prognosis</v-icon>({{
                    matchBet.bigoddsMarkets.length
                  }}) Prognóstico Bigodds
                </v-btn>
              </v-col>
            </v-row>
            <!-- MARKETS -->
            <v-row class="markets-row">
              <v-col>
                <div
                  v-for="(market, marketId) in matchBet.tiroCerteiroMarkets"
                  :key="'market-' + marketId"
                >
                  <div class="market-label">{{ market.name }}</div>
                  <v-row>
                    <v-col
                      v-for="(outcome, outcomeId) in market.outcomes"
                      :key="'bet-' + outcomeId"
                    >
                      <BetCard
                        :matchId="matchBet.match.id"
                        :market="market"
                        :outcome="outcome"
                        :tmpOutcome="
                          tempMatchDetails.matchMarkets[index]
                            .tiroCerteiroMarkets[marketId].outcomes[outcomeId]
                        "
                        :total="marketPercentages(market.outcomes)"
                        @clicked="
                          selectBet(
                            $event,
                            tempMatchDetails.matchMarkets[index]
                              .tiroCerteiroMarkets[marketId].outcomes[outcomeId]
                          )
                        "
                        :ref="
                          matchBet.match.id +
                          '-' +
                          market.name +
                          '-' +
                          outcome.name
                        "
                        :key="'bet-' + outcomeId + version"
                      ></BetCard>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
            <!-- BUTTONS -->
            <v-row
              align="center"
              justify="center"
              class="submit-row"
              v-if="
                isTiroCerteiro() &&
                index == matchDetails.matchMarkets.length - 1
              "
            >
              <v-col>
                <v-btn
                  block
                  large
                  depressed
                  color="primary"
                  :disabled="
                    minutesLeft() <= 0 || matchDetails.status == 'CLOSED'
                  "
                  v-if="minutesLeft() > 0 && matchDetails.status != 'CLOSED'"
                  @click="openDialog(matchDetails.matchMarkets.length)"
                  >Submeter</v-btn
                >
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <!-- COMMENTS -->
      <Comments
        :prognosticId="prognosticId"
        :key="'comments-' + version"
      ></Comments>
    </v-row>
    <!-- BIGODDS DIALOG -->
    <v-dialog
      v-model="showBigoddsPrognostics"
      fullscreen
      hide-overlay
      content-class="modal-dialog"
      transition="slide-x-reverse-transition"
    >
      <BigoddsPrognostics
        @close-dialog="showBigoddsPrognostics = false"
        :matchDetails="matchDetails"
      ></BigoddsPrognostics>
    </v-dialog>
    <!-- SUBMIT DIALOG -->
    <v-dialog v-model="submitDialog" max-width="372">
      <v-card>
        <v-row class="dialog-header">
          <!-- Team Logos -->
          <v-col
            style="
              flex: 0 0 90px;
              max-width: 90px;
              padding: 16px 0;
              margin-left: 30px;
            "
          >
            <div>
              <v-list-item-avatar
                class="team-icon"
                size="45"
                style="z-index: 1"
              >
                <v-img
                  :src="matchDetails.matchMarkets[0].match.homeTeam.image"
                  contain
                ></v-img>
              </v-list-item-avatar>
              <v-list-item-avatar class="team-icon" size="45">
                <v-img
                  :src="matchDetails.matchMarkets[0].match.awayTeam.image"
                  aspect-ratio="1"
                ></v-img>
              </v-list-item-avatar>
            </div>
          </v-col>
          <!-- League and Teams -->
          <v-col class="match-details">
            <v-list-item style="padding: 0">
              <v-list-item-content style="padding: 0">
                <v-list-item-subtitle
                  class="green-label"
                  style="margin-bottom: 4px !important"
                  >{{
                    matchDetails.matchMarkets[0].match.competition.name
                  }}</v-list-item-subtitle
                >
                <v-list-item-title class="team-names"
                  >{{ matchDetails.matchMarkets[0].match.homeTeam.name }} x
                  {{
                    matchDetails.matchMarkets[0].match.awayTeam.name
                  }}</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
        <v-card-title align="center">{{ submitTittle }}</v-card-title>
        <v-card-text style="padding: 0 48px 20px">{{ submitText }}</v-card-text>
        <v-list-item style="padding: 0 24px 12px 24px">
          <v-list-item-content style="padding-right: 8px">
            <v-btn
              block
              depressed
              color="secondary"
              height="48"
              @click="submitDialog = false"
              >Cancelar</v-btn
            >
          </v-list-item-content>
          <v-list-item-content style="padding-left: 8px">
            <v-btn
              block
              depressed
              color="primary"
              height="48"
              @click="submitBet()"
              >Submeter</v-btn
            >
          </v-list-item-content>
        </v-list-item>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<style scoped>
.container-row {
  min-height: 100vh;
}
.close-btn {
  background: #d8e0e6;
  color: #9aabb8;
  margin-left: 0 !important;
}
.details {
  position: relative;
  padding: 24px 120px;
}
.users-row .col {
  padding: 0 12px !important;
  flex: 0 0 50%;
  max-width: 50%;
}
.users-row .col:nth-child(3) {
  padding: 0 12px !important;
  flex: 0 0 35%;
  max-width: 35%;
}
.users-row .v-btn {
  margin-top: 10px;
  color: #26ab5e;
}
.users-row .v-btn >>> .v-btn__content {
  font-family: Gilroy-SemiBold;
  font-size: 14px;
  line-height: 24px;
  color: #26ab5e;
}
.markets-row {
  margin-top: 8px;
}
.market-label {
  margin-top: 48px;
  font-family: Gilroy-SemiBold;
  font-size: 14px;
  line-height: 16px;
  color: #304351;
}
.submit-row .col {
  width: 180px;
  flex: 0 0 180px;
  max-width: 180px;
}
.bigodds-btn {
  float: right;
}
.dialog-header {
  background: #f3f6f7;
  border-bottom: 1px solid #d8e0e6;
  max-width: 100%;
  margin: 0 0 16px 0 !important;
}
.dialog-header .team-icon {
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.08);
}
.dialog-header .team-icon:nth-child(2) {
  left: -8px;
}
.dialog-header .team-icon >>> .v-image__image {
  background-size: 24px !important;
}
.dialog-header .team-names {
  font-family: Gilroy-Bold;
  font-size: 14px;
  line-height: 16px;
  color: #304351;
}
@media only screen and (max-width: 1112px) {
  .users-row .col,
  .markets-row .col,
  .submit-row .col {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .comments {
    padding: 48px 120px;
    flex: 0 0 100%;
    max-width: 100%;
  }
}
@media only screen and (max-width: 1024px) {
  .details {
    padding: 24px 32px;
  }
  .comments {
    padding: 24px 32px;
  }
  .logos-container {
    position: absolute;
    right: 32px;
    padding-top: 36px;
  }
}
@media only screen and (max-width: 768px) {
  .container-row {
    height: initial;
  }
  .bigodds-btn {
    float: none;
  }
  .team-logos {
    padding: 12px 24px;
  }
  .logos-container {
    position: relative;
    right: 0;
    padding-top: 0;
  }
}
</style>

<script>
import Vue from "vue";
import UserAvatarList from "@/components/UserAvatarList.vue";
import Comments from "@/components/Comments.vue";
import BetCard from "@/components/BetCard.vue";
import BigoddsPrognostics from "@/components/BigoddsPrognostics.vue";

import ApiService from "@/services/api.service";

export default Vue.extend({
  name: "PrognosticDetails",
  components: {
    UserAvatarList,
    Comments,
    BetCard,
    BigoddsPrognostics,
  },
  props: {
    matchDetails: {},
    tempMatchDetails: {},
    prognosticId: String,
  },
  data: () => ({
    loading: false,
    selectBets: new Map(),
    showBigoddsPrognostics: false,
    submitDialog: false,
    version: 0,
  }),
  methods: {
    selectBet(bet, outcome) {
      const match = bet.match;
      const market = bet.market;
      const uid = this.$store.state.user.uid;

      const key = match + "-" + market;
      if (this.selectBets.has(key)) {
        if (this.selectBets.get(key) === outcome) {
          // If already selected, then deselect it
          outcome.userIds = outcome.userIds.filter((item) => {
            if (item != uid) {
              return item;
            }
          });
          this.selectBets.delete(key);
          this.$refs[key + "-" + outcome.name][0].clearSelection();
        } else {
          // If new selection, then deselect previous and add new one
          this.selectBets.get(key).userIds = this.selectBets
            .get(key)
            .userIds.filter((item) => {
              if (item != uid) {
                return item;
              }
            });
          this.$refs[
            key + "-" + this.selectBets.get(key).name
          ][0].clearSelection();
          outcome.userIds
            ? outcome.userIds.push(this.$store.state.user.uid)
            : Vue.set(outcome, "userIds", [this.$store.state.user.uid]);
          this.selectBets.set(key, outcome);
        }
      } else {
        if (outcome.userIds) {
          if (!outcome.userIds.includes(this.$store.state.user.uid)) {
            outcome.userIds.push(this.$store.state.user.uid);
          }
        } else {
          Vue.set(outcome, "userIds", [this.$store.state.user.uid]);
        }
        this.selectBets.set(key, outcome);
      }
    },
    submitBet() {
      ApiService.updatePrognoctic(this.tempMatchDetails).then(
        (response) => {
          this.submitDialog = false;
          this.$emit("update-list", {
            isUpdate: this.users.some(
              (user) => user.uid === this.$store.state.user.uid
            ),
            filter: "tiroCerteiro",
          });
        },
        (error) => {
          console.log(
            (error.response && error.response.data) ||
              error.message ||
              error.toString()
          );
        }
      );
    },
    openDialog(length) {
      if (this.minutesLeft() > 0) {
        const subs = 3 * length;
        if (this.selectBets.size == subs) {
          this.submitDialog = true;
        } else {
          this.$emit("tiro-certeiro-error", subs);
        }
      } else {
        this.$emit("tiro-certeiro-error", -1);
      }
    },
    closeDialog() {
      for (const ref in this.$refs) {
        this.$refs[ref][0]?.clearSelection();
      }
      this.selectBets = new Map();
      this.$emit("close-dialog");
    },
    isTiroCerteiro() {
      return this.$route.path.includes("tiro-certeiro");
    },
    isBigometro() {
      return this.$route.path.includes("bigometro");
    },
    minutesLeft() {
      return this.$moment(
        this.matchDetails.matchMarkets[0].match.date +
          " " +
          this.matchDetails.matchMarkets[0].match.hour
      ).diff(this.$moment(), "minutes");
    },
  },
  computed: {
    users() {
      let users = [];
      this.matchDetails.matchMarkets[0].tiroCerteiroMarkets[0].outcomes.forEach(
        (outcome) => {
          users = users.concat(outcome.users);
        }
      );
      return users;
    },
    submitTittle() {
      return this.users.some((user) => user.uid === this.$store.state.user.uid)
        ? "Alterar prognóstico"
        : "Submissão de prognóstico";
    },
    submitText() {
      return this.users.some((user) => user.uid === this.$store.state.user.uid)
        ? "Tem a certeza que pretende alterar o seu prognóstico? Esta acção é reversível e pode ser alterado posteriormente."
        : "Tem a certeza que pretende submeter o prognóstico? Se posteriormente prentender alterar poderá sempre o fazer através do jogo.";
    },
    marketPercentages() {
      return (outcomes) => {
        let sum = 0;
        outcomes.forEach((element) => {
          sum = sum + element.users.length;
        });
        return sum;
      };
    },
  },
  watch: {
    matchDetails: function (val) {
      console.log(val);
    },
    tempMatchDetails: function (val) {
      this.version += 1;
    },
  },
});
</script>
